// GN: complementa a galeria do Dawn (layout "thumbnail") com selo, pontos de navegação,
// botão "Ver vídeo" e um grupo "Vídeos" separado na coluna de miniaturas.
(() => {
  const textos = document.currentScript.dataset;
  const PLAY = '<svg class="gn-play" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.4-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z" fill="currentColor"/></svg>';

  const ehVideo = (slide) => slide.classList.contains('product__media-item--full') || !!slide.querySelector('deferred-media, video');

  function montar(galeria) {
    const viewer = galeria.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    galeria.classList.add('gn-galeria');
    const slides = [...viewer.querySelectorAll('.product__media-item')];
    const ativar = (slide) => galeria.setActiveMedia?.(slide.dataset.mediaId, false);

    // Selo "Imagens ilustrativas" removido a pedido do cliente (2026-10-10)
    viewer.querySelector('.gn-galeria__selo')?.remove();

    // Espaço dos vídeos: faixa própria abaixo da mídia principal.
    // As miniaturas de vídeo do Dawn continuam no DOM (o Dawn as usa em setActiveMedia), só ocultas.
    const lista = galeria.querySelector('[id^="Slider-Thumbnails"]');
    const slidesVideo = slides.filter(ehVideo);
    galeria.querySelector('.gn-galeria__videos')?.remove();
    if (slidesVideo.length) {
      lista?.querySelectorAll('[data-target]').forEach((li) => {
        if (slidesVideo.some((s) => s.dataset.mediaId === li.dataset.target)) li.classList.add('gn-galeria__miniatura-video');
      });
      const faixa = document.createElement('div');
      faixa.className = 'gn-galeria__videos';
      faixa.innerHTML = `<p class="gn-galeria__videos-titulo">${PLAY} ${textos.videos}</p><div class="gn-galeria__videos-lista"></div>`;
      const listaVideos = faixa.lastElementChild;
      slidesVideo.forEach((slide, i) => {
        const capa = lista?.querySelector(`[data-target="${slide.dataset.mediaId}"] img`) || slide.querySelector('img');
        const cartao = document.createElement('button');
        cartao.type = 'button';
        cartao.className = 'gn-galeria__video';
        cartao.dataset.alvo = slide.dataset.mediaId;
        cartao.setAttribute('aria-label', `${textos.verVideo} ${i + 1}`);
        cartao.innerHTML = `${capa ? `<img src="${capa.currentSrc || capa.src}" alt="" loading="lazy">` : ''}
          <span class="gn-galeria__video-play">${PLAY}</span>
          <span class="gn-galeria__video-legenda">${textos.videos.replace(/s$/, '')} ${i + 1}</span>`;
        cartao.addEventListener('click', () => ativar(slide));
        listaVideos.append(cartao);
      });
      viewer.after(faixa);

      // Atalho "Vídeo" (ícone de play) sobre a foto (no celular a faixa some e o vídeo fica como slide da galeria)
      viewer.querySelector('.gn-galeria__atalho-video')?.remove();
      const atalho = document.createElement('button');
      atalho.type = 'button';
      atalho.className = 'gn-galeria__atalho-video';
      atalho.innerHTML = `${PLAY} ${textos.videos.replace(/s$/, '')}`;
      atalho.setAttribute('aria-label', textos.verVideo);
      atalho.addEventListener('click', () => {
        const alvo = slidesVideo[0];
        ativar(alvo);
        // No celular o Dawn marca a mídia mas não rola o carrossel até ela
        const trilho = alvo.parentElement;
        trilho?.scrollTo({ left: alvo.offsetLeft - trilho.offsetLeft, behavior: 'smooth' });
      });
      viewer.append(atalho);
    }

    // Pontos de navegação
    galeria.querySelector('.gn-galeria__pontos')?.remove();
    if (slides.length > 1) {
      const pontos = document.createElement('div');
      pontos.className = 'gn-galeria__pontos';
      slides.forEach((slide, i) => {
        const ponto = document.createElement('button');
        ponto.type = 'button';
        ponto.className = 'gn-galeria__ponto' + (ehVideo(slide) ? ' gn-galeria__ponto--video' : '');
        ponto.setAttribute('aria-label', `${textos.irPara} ${i + 1}`);
        ponto.addEventListener('click', () => ativar(slide));
        pontos.append(ponto);
      });
      viewer.after(pontos);

      const marcar = (slideAtivo) => {
        const idx = slides.indexOf(slideAtivo);
        [...pontos.children].forEach((p, i) => p.classList.toggle('is-active', i === idx));
        viewer.classList.toggle('gn-galeria--video-ativo', !!slideAtivo && ehVideo(slideAtivo));
        galeria.querySelectorAll('.gn-galeria__video').forEach((c) =>
          c.classList.toggle('is-active', c.dataset.alvo === slideAtivo?.dataset.mediaId));
      };
      marcar(slides.find((s) => s.classList.contains('is-active')) || slides[0]);
      new MutationObserver(() => marcar(slides.find((s) => s.classList.contains('is-active')))).observe(
        viewer, { subtree: true, attributes: true, attributeFilter: ['class'] }
      );
      viewer.addEventListener('slideChanged', (e) => marcar(e.detail?.currentElement));
    }
  }

  const iniciar = () => document.querySelectorAll('media-gallery').forEach(montar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  // O Dawn re-renderiza a galeria ao trocar de variação (hide_variants); monta de novo.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(iniciar, 50));
  }
})();
